import { useEffect } from 'react';

/**
 * Sets `<title>` and `<meta name="description">` on the page.
 * Designed for static / mostly-static pages; reactive to title/description changes.
 */
export const useDocumentMeta = ({ title, description }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (!description) return;
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', 'description');
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', description);
  }, [title, description]);
};
